var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 16,
    height: 16,
    transform: "rotate(-90 0 16)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_596_1887",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_596_1887",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAABZklEQVR4nO3aPU7DQBRF4RMKDGw8EkKiTgGLoECsiIYCiR9RmiJxE8Wx48xM3tjnk1z7vqMUkRKQJEmSJEmSJEmSJEmSJMWx2j3F3AIb4Af4AO6BpuSAwhrgAfgE/oAn4K7EizdAu/e8Ms/YDdvb9u99zv3iFfB94MVzjN0XuQV+gavcA756Xj6n2Mcit2wbZPd4ZMAcYg9Fbtk2CDGk1tjhbrsGXgYGvQE3pQYlEPamsMMmCH9L+IEjVHNDNUMPqG57dYOpczNQ1/Cath5UwwE1bBwl8iGRt00S8aCIm5KIdFikLVlEODDChiIueehiIncucfDiIndKHr7YyJ0SARYfuZMzhJH35Ahi5B4pwxh5QIpARh7pnFBGPtGUYEae6JRwRj7T2J/7Q/0loFZjPq1+khOZGtvIE5wa28hnGBvbyAkMxTZyQn2xjZxBA6yB992zxq9wkiRJkiRJkiRJkiRJkqTy/gHHXxTfFM457gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.1f1bce2c92426c5e7173b1beddb4dc5c.svg";
export { ForwardRef as ReactComponent };